import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { IModalComponent, DropdownField, Btn, Field, TextField, FormButtonDisabler } from '@samc/centricity-core';
import { IFieldValues, IUpdateContractName } from '@/Interfaces';
import { FieldValuesSource } from '../../Sources';
import { CachedDataSource } from '../../Sources/BaseDataSources';

@Component({
  name: 'update-contract-name-modal',
  components: { DropdownField, TextField, Btn, Field, FormButtonDisabler }
})
export default class UpdateContractNameModal extends Vue implements IModalComponent {
  @Prop({ required: true }) public loanIds!: number[];
  @Prop() public addCloseProp!: (callback: () => Promise<any>) => void;
  @Prop() public closeProp!: () => void;

  public contractSource: string[] = [];
  public nameSource: FieldValuesSource | IFieldValues[] = [];
  public contractField: string = '';
  public fValue: string = '';
  public selectedContract: string = '';


  @Watch('selectedContract', { immediate: true })
  public updateContractValues(newContract: string | null) {
    console.log("selected", newContract);
    if (newContract !== null && newContract.length > 0) {
      this.nameSource = new FieldValuesSource(newContract); 
    } else {
      this.nameSource = [];
    }
  }


  public mounted() {
    this.contractSource.push("Custodian Contract Name");
    this.contractSource.push("MLPA Contract Name");
    this.contractSource.push("Servicing Contract Name");

    this.addCloseProp(async () => {
      return {
        newLoans: this.loanIds,
        contractName: this.fValue, //value
        contractField: this.selectedContract //name
      } as IUpdateContractName;
    });
  }


  public async addNewValue(tag: string) {
    if (this.nameSource !== null) {
      const data = { fValue: tag } as any;
      await (this.nameSource as CachedDataSource<IFieldValues>).addItem({ fValue: tag } as any);
      this.fValue = data.fValue;
    }
  }
}
